import { MagnifierIcon } from '@/common/icons/general.tsx'
import { IconType } from '@/common/icons/types.ts'
import { Input } from '@/app/common/components/input/Input'
import { InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils.ts'

type InputProps = InputHTMLAttributes<HTMLInputElement>

export default function SearchInput({ className, ...props }: InputProps) {
  return (
    <div className="relative rounded-md shadow-sm">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <MagnifierIcon type={IconType.Outline} />
      </div>
      <Input className={cn('shadow-none pl-10', className)} {...props} />
    </div>
  )
}
